// Sets the height of the member-ship slides to that of the active form.
const setSlideHeight = function () {
    const activeForm = $('.membership-body:not(.inactive)');

    $(".membership-slides").height("");
    if (activeForm.find(".membership-slides-slide.active").length == 1) {
        const height = activeForm.find(".membership-slides-slide.active").height();
        activeForm.find(".membership-slides").height( height + "px");
    }
};

export default setSlideHeight;